import { Link } from 'react-router-dom';

interface LegalLinksProps {
  newTab?: boolean;
  className?: string;
}

const LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

export function LegalLinks({ newTab = false, className }: LegalLinksProps) {
  return (
    <p className={className}>
      {LINKS.map((link, index) => (
        <span key={link.to}>
          {index > 0 && <span aria-hidden="true"> · </span>}
          {newTab ? (
            <a href={link.to} target="_blank" rel="noopener noreferrer" className="hover:underline">
              {link.label}
            </a>
          ) : (
            <Link to={link.to} className="hover:underline">
              {link.label}
            </Link>
          )}
        </span>
      ))}
    </p>
  );
}
